// extracted by mini-css-extract-plugin
export default {"Cropper":"Cropper_Cropper__3Yd3Q","btn":"Cropper_btn__Qy9L4"};